import React, { useEffect, useMemo, useState } from 'react'

const PAYMENT_LINK_PARAM_NAMES = ['link', 'url', 'paymentLink', 'payment_link', 'paymentUrl']
const UPI_PARAM_NAMES = ['pa', 'pn', 'tr', 'tn', 'am', 'cu', 'mc', 'tid']

const getRawQueryParam = paramName => {
	const search = window.location.search
	const prefix = `?${paramName}=`

	if (!search.startsWith(prefix)) return ''

	try {
		return decodeURIComponent(search.slice(prefix.length).replace(/\+/g, '%20'))
	} catch (error) {
		return search.slice(prefix.length)
	}
}

const getPaymentLink = () => {
	const params = new URLSearchParams(window.location.search)

	for (const paramName of PAYMENT_LINK_PARAM_NAMES) {
		const rawLink = getRawQueryParam(paramName)

		if (rawLink) {
			return rawLink
		}

		const link = params.get(paramName)

		if (link) {
			return link
		}
	}

	if (params.get('pa')) {
		const upiParams = new URLSearchParams()

		UPI_PARAM_NAMES.forEach(paramName => {
			const value = params.get(paramName)

			if (value) {
				upiParams.set(paramName, value)
			}
		})

		return `upi://pay?${upiParams.toString()}`
	}

	return ''
}

const isValidPaymentLink = link => {
	if (!link) return false

	return /^(https?:\/\/|upi:\/\/)/i.test(link)
}

const UpiPayRoutes = () => {
	const [opening, setOpening] = useState(false)

	const paymentLink = useMemo(() => getPaymentLink(), [])
	const canOpenPayment = isValidPaymentLink(paymentLink)

	useEffect(() => {
		alert(`UPI payment page loaded.\n\nReceived params:\n${window.location.search || 'No params found'}`)

		if (paymentLink) {
			alert(`Payment link generated:\n${paymentLink}`)
			return
		}

		alert('No payment link could be generated from URL params.')
	}, [paymentLink])

	const handlePayNow = () => {
		alert('Pay Now button clicked.')

		if (!canOpenPayment) {
			alert('Payment link is missing or invalid. Cannot open payment gateway.')
			return
		}

		setOpening(true)
		alert(`Opening payment gateway now:\n${paymentLink}`)
		window.location.href = paymentLink
	}

	return (
		<div style={styles.wrapper}>
			<div style={styles.card}>
				<div style={styles.iconWrap}>
					<svg
						width="36"
						height="36"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<rect x="2" y="5" width="20" height="14" rx="2" />
						<path d="M2 10h20" />
						<path d="M7 15h4" />
					</svg>
				</div>

				<h1 style={styles.heading}>Complete Payment</h1>
				<p style={styles.text}>
					{canOpenPayment
						? 'Tap the button below to open the payment gateway.'
						: 'Payment link is missing or invalid.'}
				</p>

				<button
					type="button"
					style={{
						...styles.payButton,
						...(canOpenPayment ? styles.payButtonEnabled : styles.payButtonDisabled),
					}}
					onClick={handlePayNow}
					disabled={!canOpenPayment || opening}
				>
					{opening ? 'Opening...' : 'Pay Now'}
				</button>
			</div>
		</div>
	)
}

const styles = {
	wrapper: {
		minHeight: '100vh',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#F6F7FB',
		padding: '20px',
		fontFamily:
			'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
	},
	card: {
		width: '100%',
		maxWidth: '420px',
		backgroundColor: '#FFFFFF',
		borderRadius: '8px',
		padding: '32px 24px',
		textAlign: 'center',
		boxShadow: '0 12px 32px rgba(15, 23, 42, 0.08)',
	},
	iconWrap: {
		width: '64px',
		height: '64px',
		margin: '0 auto 20px',
		borderRadius: '50%',
		backgroundColor: '#EAF2FF',
		color: '#1D4ED8',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	heading: {
		margin: '0 0 10px',
		color: '#111827',
		fontSize: '24px',
		fontWeight: 700,
		letterSpacing: 0,
	},
	text: {
		margin: 0,
		color: '#4B5563',
		fontSize: '15px',
		lineHeight: 1.5,
	},
	payButton: {
		width: '100%',
		minHeight: '52px',
		marginTop: '28px',
		border: 0,
		borderRadius: '8px',
		fontSize: '16px',
		fontWeight: 700,
		cursor: 'pointer',
	},
	payButtonEnabled: {
		backgroundColor: '#1D4ED8',
		color: '#FFFFFF',
	},
	payButtonDisabled: {
		backgroundColor: '#D1D5DB',
		color: '#6B7280',
		cursor: 'not-allowed',
	},
}

export default UpiPayRoutes
